import {Ocr, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalOcrPage} from "./PortalOcrPage";

export enum OcrPdfaType {
	NONE = "none",
	_1A = "1a",
	_1B = "1b",
	_2A = "2a",
	_2B = "2b",
	_2U = "2u",
	_3A = "3a",
	_3B = "3b",
	_3U = "3u"
}

export class PortalOcr extends Ocr implements Parameter {
	public imageDpiActive?: boolean;
	public optimizationActive?: boolean;
	public pdfaMode?: OcrPdfaType;

	constructor(data: any) {
		super(data);

		this.page = PortalOcrPage.fromJson(data?.page);
		this.imageDpiActive = FunctionHelper.exists(data?.imageDpiActive) ? data.imageDpiActive : false;
		this.optimizationActive = FunctionHelper.exists(data?.optimizationActive) ? data.optimizationActive : false;
		this.pdfaMode = FunctionHelper.exists(data?.pdfaMode) ? data.pdfaMode : OcrPdfaType.NONE;
	}

	public static getImageDpiActiveDefault(): boolean {
		return false;
	}

	public static getOptimizationActiveDefault(): boolean {
		return false;
	}

	public static getPdfaModeDefault(): OcrPdfaType {
		return OcrPdfaType.NONE;
	}

	public static fromJson(data: any): PortalOcr {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalOcr(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'imageDpiActive': this.imageDpiActive,
			'optimizationActive': this.optimizationActive,
			'pdfaMode': this.pdfaMode,
		};
	}

	public clone(): PortalOcr {
		return PortalOcr.fromJson(this.toJson());
	}
}